import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from 'primeng/table';
import { TooltipModule } from "primeng/tooltip";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { InputMaskModule } from 'primeng/inputmask';
import { MessagesModule } from 'primeng/messages';
import {InputSwitchModule} from 'primeng/inputswitch';
import { ClienteEditarRoutingModule } from "./cliente-editar-routing.module";
import { ClienteEditarComponent } from "./cliente-editar.component";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmationService } from "primeng/api";

@NgModule({
    imports: [
        CommonModule,            
        ClienteEditarRoutingModule,
        FormsModule,       
        TableModule,
        ButtonModule,
        InputTextModule,
        TooltipModule,
        DropdownModule,
        InputMaskModule,
        MessagesModule,
        InputSwitchModule,
        ProgressSpinnerModule,
        ConfirmDialogModule

    ],
    declarations: [ClienteEditarComponent],
    providers: [ConfirmationService]
})
export class ClienteEditarModule { }
